<template>
  <base-form :title="$t('generic.details')"
             :loading="loading"
             @submit="submit">
    <div class="flex">

      <div class="pr-8 my-8">
        <image-upload @on-change="onLogoChange"
                      :name="model.name"
                      :circle="false"
                      :src="model.image">
        </image-upload>
      </div>
      <div class="col-12 col-xl-10">
        <div>
          <label class="input-label">
            {{$t('settings.products.details.product_type.label')}}
          </label>
          <div class="radio-wrapper">
            <base-radio inline v-model="model.product_type" :label="product_type.JOBPOSTING">
              {{$t('settings.products.details.product_type.job_posting')}}
            </base-radio>
            <base-radio inline v-model="model.product_type" :label="product_type.JOB_UP_SELL">
              {{$t('settings.products.details.product_type.job_up_sell')}}
            </base-radio>
            <base-radio inline v-model="model.product_type" :label="product_type.FEATUREDEMPLOYER">
              {{$t('settings.products.details.product_type.featured_employer')}}
            </base-radio>
            <base-radio inline v-model="model.product_type" :label="product_type.CREDIT">
              {{$t('settings.products.details.product_type.credit')}}
            </base-radio>
            <base-radio inline v-model="model.product_type" :label="product_type.CONTRACT">
              {{$t('settings.products.details.product_type.contract')}}
            </base-radio>
            <base-radio inline v-model="model.product_type" :label="product_type.SLOT">
              {{$t('settings.products.details.product_type.slot')}}
            </base-radio>
            <base-radio inline v-model="model.product_type" :label="product_type.RECRUITER_SEAT">
              {{$t('settings.products.details.product_type.recruiter_seat')}}
            </base-radio>
            <base-radio inline v-model="model.product_type" :label="product_type.CUSTOM">
              {{$t('settings.products.details.product_type.custom')}}
            </base-radio>
          </div>
        </div>
        <div>
          <label class="input-label">
            {{$t('settings.products.details.payment_type.label')}}
          </label>
          <div class="radio-wrapper">
            <base-radio v-if="!isRecurringProductType || model.product_type === 'custom'"
                        inline
                        v-model="model.payment_type"
                        :label="payment_type.once">
              {{$t('settings.products.details.payment_type.once')}}
            </base-radio>
            <base-radio inline v-model="model.payment_type" :label="payment_type.recurring"
                        v-if="isRecurringProductType">
              {{$t('settings.products.details.payment_type.recurring')}}
            </base-radio>
          </div>
        </div>
        <div v-if="isRecurring">
          <label class="input-label">
            {{$t('settings.products.details.recurring_type.label')}}
          </label>
          <div class="radio-wrapper">
            <base-radio inline v-model="model.recurring_type" label="monthly">
              {{$t('settings.products.details.recurring_type.monthly')}}
            </base-radio>
            <base-radio inline v-model="model.recurring_type" label="quarterly">
              {{$t('settings.products.details.recurring_type.quarterly')}}
            </base-radio>
            <base-radio inline v-model="model.recurring_type" label="yearly">
              {{$t('settings.products.details.recurring_type.yearly')}}
            </base-radio>
          </div>

        </div>
        <div v-if="model.product_type === product_type.CONTRACT">
          <fg-input :label="$t('settings.products.details.jobPostingProduct')"
                    :error="getError($t('settings.products.details.jobPostingProduct'))">
            <product-select :options="jobPostingProducts"
                            :name="$t('settings.products.details.jobPostingProduct')"
                            v-model="selectedProduct"
                            v-validate="'required|not_empty_object'"
                            @change="onProductSelect">
            </product-select>
          </fg-input>
        </div>
        <div v-if="model.product_type === product_type.JOB_UP_SELL">
          <fg-input :label="$t('settings.products.details.upSellType')">
            <job-upsell-select v-model="model.job_up_sell">
            </job-upsell-select>
          </fg-input>
        </div>
        <div>
          <fg-input :name="$t('settings.products.details.name.label')"
                    :label="$t('settings.products.details.name.label')"
                    :placeholder="$t('settings.products.details.name.placeholder')"
                    v-model="model.name"
                    v-validate="validations.name"
                    :error="getError($t('settings.products.details.name.label'))">
          </fg-input>
          <fg-input :label="$t('settings.products.details.text.label')"
                    :error="getError($t('settings.products.details.text.label'))">
            <wysiwyg :name="$t('settings.products.details.text.label')"
                     class="form-control"
                     key="product-text"
                     :class="{'has-danger': getError($t('job.create.details.jobText'))}"
                     required
                     v-validate="validations.text"
                     v-model="model.text">
            </wysiwyg>
          </fg-input>
        </div>
        <div >
          <section-separator has-border size="lg">
            {{$t('settings.products.details.priceAndSettings')}}
          </section-separator>
        </div>
        <div >
          <fg-input :placeholder="$t('settings.products.details.price.placeholder')"
                    :label="$t('settings.products.details.price.label')"
                    :name="$t('settings.products.details.price.label')"
                    :error="getError($t('settings.products.details.price.label'))"
                    required
                    type="number"
                    v-validate="validations.price"
                    v-model.number="model.price">
          </fg-input>
        </div>
        <div >
          <fg-input :placeholder="$t('settings.products.details.priceNormal.placeholder')"
                    :label="$t('settings.products.details.priceNormal.label')"
                    :name="$t('settings.products.details.priceNormal.label')"
                    type="number"
                    v-model.number="model.price_normal">
          </fg-input>
        </div>
        <div class="grid grid-cols-6">
          <div class="col-span-3 md:col-span-1">
            <fg-input :label="$t('settings.products.details.active')"
                      :error="getError($t('settings.products.details.active'))"
                      class="ml-1">
              <base-switch v-model="model.active"
                           on-text="YES"
                           off-text="NO">
              </base-switch>
            </fg-input>
          </div>
          <div class="col-span-3 md:col-span-1" v-if="!isCredit">
            <fg-input :label="$t('settings.products.details.trial')"
                      :error="getError($t('settings.products.details.trial'))">
              <base-switch v-model="model.trial"
                           on-text="YES"
                           off-text="NO">
              </base-switch>
            </fg-input>
          </div>

          <div class="col-span-3 md:col-span-1" v-if="isJob">
            <fg-input :label="$t('settings.products.details.premium')"
                      :error="getError($t('settings.products.details.premium'))">
              <base-switch v-model="model.premium"
                           on-text="YES"
                           off-text="NO">
              </base-switch>
            </fg-input>
          </div>

          <div class="col-span-3 md:col-span-1" v-if="isJob">
            <fg-input :label="$t('settings.products.details.showLogo')"
                      :error="getError($t('settings.products.details.showLogo'))">
              <base-switch v-model="model.show_logo"
                           on-text="YES"
                           off-text="NO">
              </base-switch>
            </fg-input>
          </div>
          <div class="col-span-3 md:col-span-1" v-if="isJob">
            <fg-input :label="$t('settings.products.details.emailOnly')"
                      :error="getError($t('settings.products.details.emailOnly'))">
              <base-switch v-model="model.email_only"
                           on-text="YES"
                           off-text="NO">
              </base-switch>
            </fg-input>
          </div>

          <div class="col-span-5 md:col-span-1" v-if="false">
            <fg-input :label="$t('settings.products.details.accessCVDatabase')"
                      :error="getError($t('settings.products.details.accessCVDatabase'))">
              <base-switch v-model="model.access_cv_database"
                           on-text="YES"
                           off-text="NO">
              </base-switch>
            </fg-input>
          </div>
        </div>

        <div v-if="model.access_cv_database">
          <fg-input :placeholder="$t('settings.products.details.amountCvDatabase.placeholder')"
                    :label="$t('settings.products.details.amountCvDatabase.label')"
                    :name="$t('settings.products.details.amountCvDatabase.label')"
                    :error="getError($t('settings.products.details.amountCvDatabase.label'))"
                    type="number"
                    v-validate="validations.amount_cv_database"
                    min="1"
                    step="1"
                    v-model.number="model.amount_cv_database">
          </fg-input>
        </div>
        <div v-if="isJob">
          <fg-input :placeholder="$t('settings.products.details.boostFactor.placeholder')"
                    :label="$t('settings.products.details.boostFactor.label')"
                    :name="$t('settings.products.details.boostFactor.label')"
                    :error="getError($t('settings.products.details.boostFactor.label'))"
                    type="number"
                    v-validate="validations.boost_factor"
                    min="0.1"
                    max="5"
                    step="0.1"
                    v-model.number="model.boost_factor">
          </fg-input>
        </div>
        <div v-if="isJob">
          <fg-input :placeholder="$t('settings.products.details.jobDays.placeholder')"
                    :label="$t('settings.products.details.jobDays.label')"
                    :name="$t('settings.products.details.jobDays.label')"
                    type="number"
                    v-validate="validations.job_days"
                    :error="getError($t('settings.products.details.jobDays.label'))"
                    v-model.number="model.job_days">
          </fg-input>
        </div>
        <div>
          <fg-input :placeholder="$t('settings.products.details.amount.placeholder')"
                    :label="$t('settings.products.details.amount.label')"
                    :name="$t('settings.products.details.amount.label')"
                    type="number"
                    v-model.number="model.amount">
          </fg-input>
        </div>
        <div>
          <fg-input :label="$t('generic.paymentTypes')">
            <payment-type-select v-model="model.payment_types"
                                 multiple>
            </payment-type-select>
          </fg-input>
        </div>
        <div>
          <fg-input :placeholder="$t('settings.products.details.order_rank.placeholder')"
                    :label="$t('settings.products.details.order_rank.label')"
                    :name="$t('settings.products.details.order_rank.label')"
                    type="number"
                    v-model.number="model.order_rank">
          </fg-input>
        </div>

      </div>
    </div>
    <template v-slot:content>
      <template v-if="isEditMode">
        <div class="mt-3">
          <section-separator has-border size="lg" no-margin-top="">
            {{$t('job.create.jobBoards.title')}}
          </section-separator>
        </div>
        <div>
          <product-job-board :product="product"></product-job-board>
        </div>
      </template>

      <div class="mt-3">
        <section-separator has-border size="lg" no-margin-top="">
          {{$t('settings.products.labels.benefits')}}
        </section-separator>
      </div>
      <div>
        <data-table :entity="'product'"
                    :data="model.benefits.filter(b => b.lang === benefitsLanguage)"
                    :columns="benefitsColumns"
                    operations="add,delete"
                    :disable-permission-checks="true"
                    :allowApiDelete="false"
                    :go-to-details-on-row-click="false"
                    :go-to-add-on-click="false"
                    :show-confirm-before-delete="false"
                    :show-pagination="false"
                    :clickable="false"
                    :searchable="false"
                    @on-add="addBenefit"
                    @on-delete="deleteBenefit"
                    ref="table">

          <template v-slot:name="{row, index}">
            <fg-input :placeholder="$t('product.labels.benefitName')"
                      v-model="row.name"
                      class="benefit_name-input">
            </fg-input>
          </template>
          <template v-slot:icon="{row, index}">
            <icon-autocomplete v-model="row.icon"></icon-autocomplete>
          </template>
        </data-table>
      </div>
    </template>
  </base-form>
</template>
<script>
  import { Upload, DatePicker } from 'element-ui'
  import Vue from 'vue'
  import { FgInput } from 'src/components'
  import ImageUpload from 'src/components/ImageUpload'
  import ProductJobBoard from './ProductJobBoard'
  import ProductRules from './ProductRules'
  import ProductSelect from 'src/components/Autocomplete/ProductSelect'
  import PaymentTypeSelect from 'src/components/Autocomplete/SimplePaymentTypeSelect'
  import JobUpsellSelect from './JobUpsellSelect'
  import IconAutocomplete from 'src/components/Autocomplete/IconAutocomplete'
  import Wysiwyg from 'src/components/Wysiwyg/RedactorWysiwyg'
  import { productType } from 'src/config/productType'

  Vue.use(DatePicker)

  export default {
    components: {
      FgInput,
      ImageUpload,
      Wysiwyg,
      IconAutocomplete,
      ProductJobBoard,
      ProductSelect,
      JobUpsellSelect,
      ProductRules,
      PaymentTypeSelect,
      [Upload.name]: Upload
    },
    props: {
      product: {
        type: Object,
        default: () => {
          return {
            job_days: 0
          }
        }
      },
      loading: Boolean
    },
    computed: {
      isJob () {
        return this.model.product_type === this.product_type.JOBPOSTING
      },
      isCredit () {
        return this.model.product_type === this.product_type.CREDIT
      },
      isContract () {
        return this.model.product_type === this.product_type.CONTRACT
      },
      isCustom () {
        return this.model.product_type === this.product_type.CUSTOM
      },
      isRecruiterSeat() {
        return this.model.product_type === this.product_type.RECRUITER_SEAT
      },
      isRecurringProductType() {
        return this.checkRecurringProductType(this.model.product_type)
      },
      isRecurring () {
        return this.model.payment_type === this.payment_type.recurring
      },
      isEditMode() {
        return this.product && this.product.id
      },
      jobPostingProducts() {
        return this.$store.getters['config/jobPostingProducts']
      },
      benefitsLanguage() {
        return this.$store.state.config.textLanguage
      },
      benefitsColumns () {
        return [
          {
            prop: 'name',
            label: this.$t('product.labels.benefitName'),
            minWidth: '200px',
            sortable: true
          },
          {
            prop: 'icon',
            label: this.$t('product.labels.benefitIcon'),
            minWidth: '190px',
            sortable: true
          },
        ]
      }
    },
    data () {
      return {
        formValid: true,
        product_type: productType,
        payment_type: {
          once: 'once',
          recurring: 'recurring'
        },
        selectedProduct: {},
        model: {
          product_type: this.$route.query.product_type || '',
          payment_type: '',
          payment_types: [],
          product_id: '',
          job_up_sell: '',
          email_only: false,
          access_cv_database: false,
          amount_cv_database: 1,
          recurring_type: null,
          text: '',
          title: '',
          name: '',
          logo: '',
          price: 0,
          price_normal: '',
          trial: false,
          premium: false,
          active: false,
          show_logo: false,
          boost_factor: 0.1,
          job_days: 0,
          amount: '',
          benefits: [],
          order_rank: null,
        },
        validations: {
          name: {
            required: true,
            max: 100
          },
          text: {
            required: true
          },
          price: {
            required: true
          },
          boost_factor: {
            min_value: 0,
            max_value: 5,
          },
          amount_cv_database: {
            min_value: 1,
          },
          job_days: {
            min_value: 0
          },
          required: {
            required: true,
            min: 10
          }
        }
      }
    },
    methods: {
      checkRecurringProductType(type) {
        return [this.product_type.SLOT, this.product_type.FEATUREDEMPLOYER, this.product_type.CUSTOM, this.product_type.RECRUITER_SEAT].includes(type)
      },
      addBenefit() {
        this.model.benefits.push({
          lang: this.benefitsLanguage,
          name: '',
          icon: 'PackageIcon',
          key: this.model.benefits.length
        })
      },
      deleteBenefit(row) {
        let index = this.model.benefits.findIndex(b => b.key === row.key)
        if (index !== -1) {
          this.model.benefits.splice(index, 1)
        }
      },
      onLogoChange (src) {
        this.model.image = src
      },
      onProductSelect(product) {
        this.model.product_id = product.id
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async submit () {
        let isValid = await this.$validator.validateAll()
        if (isValid) {
          let data = {
            ...this.model
          }
          let keysToDelete = ['job_days', 'boost_factor', 'premium', 'price_normal']
          if (this.model.product_type !== productType.JOB_UP_SELL) {
            keysToDelete.push('job_up_sell')
          }
          if (this.model.payment_type !== this.payment_type.recurring) {
            keysToDelete.push('recurring_type')
          }
          if (this.model.product_type !== productType.CONTRACT) {
            keysToDelete.push('product_id')
          }
          keysToDelete.forEach(key => {
            if (!data[key]) {
              delete data[key]
            }
          })

          if (!data.image) {
            delete data.image
          }

          this.$emit('submit', data)
        }
      },
    },
    watch: {
      'model.product_type': function (value) {
        if (this.model.product_type === this.product_type.CREDIT) {
          this.model.payment_type = this.payment_type.once
        }
        if (this.checkRecurringProductType(value)) {
          this.model.payment_type = this.payment_type.recurring
        } else {
          this.model.payment_type = this.payment_type.once
        }
      },
      'model.payment_type': function () {
        if (this.model.payment_type !== this.payment_type.recurring) {
          this.model.recurring_type = null
        }
      },
      'model.trial': function (newVal) {
        if (newVal) {
          this.model.payment_type = this.payment_type.once
        }
      }
    },
    mounted () {
      this.$watch('product', newProduct => {
        const product_id = this.model.product_id
        this.model = {
          ...this.model,
          ...newProduct,
          product_id,
          benefits: newProduct.benefits || []
        }
        if (product_id && !this.selectedProduct.id) {
          this.selectedProduct = this.jobPostingProducts.find(p => p.id === product_id)
        }
        if (newProduct.active === null) {
          this.model.active = false
        }
        if (newProduct.trial === null) {
          this.model.trial = false
        }
      }, {immediate: true, deep: true})
    }

  }
</script>
<style lang="scss">
.benefit_name-input {
  padding-top: 10px;
}
.radio-wrapper .form-radio{
  @apply mb-3;
}
</style>
